import { CrossIcon } from "components/tabs/TabTitle";
import * as React from "react";
export const MyCommandCell = (props) => {
  const { dataItem } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = dataItem.ProductID === undefined;
  console.log(dataItem[props.editField]);
  return inEdit ? (
    <td className="k-command-cell">
      <div className="cursor-pointer">
        <CrossIcon
          onClick={() =>
            isNewItem ? props.discard(dataItem) : props.cancel(dataItem)
          }
        />
      </div>
    </td>
  ) : (
    <td className="k-command-cell">
      <div className="cursor-pointer">
        <CrossIcon onClick={() => props.remove(dataItem)} />
      </div>
    </td>
  );
};
